import React, {useEffect, useState} from 'react';
import EmployeeTableList from "@pages/employer/edit/EmployeeTableList";
import {requestGetEmployeeList, requestSaveEmployee} from "@app/services/EmployeeService";
import {ResponseCode as ResponseStatus} from "@app/constants/Common";
import {alertMessage} from "@app/constants/Messages";
import {showSuccessMessageSaveData} from "@pages/candidate/Common";

const EmployeesContent = (props) => {
    const [currentEmployees, setCurrentEmployees] = useState([]);
    const [otherEmployees, setOtherEmployees] = useState([]);
    const [isLoading, setIsLoading] = useState(false)

    const {employerId, onChange} = props
    const fetchEmployeeList = (empId) => {
        setIsLoading(true)

        // let params = {page: page, size: DEFAULT_PAGE_SIZE}
        requestGetEmployeeList({employer_id: empId}). then((res) => {
            const allEmployees = res.content.employees;
            const currEmployees = []
            const othEmployees = []
            allEmployees.forEach((item, index) => {
                if (item.is_current) {
                    currEmployees.push(item);
                } else {
                    othEmployees.push(item);
                }
            });
            setCurrentEmployees(currEmployees);
            setOtherEmployees(othEmployees);
        }).catch((error) => {
            setCurrentEmployees([]);
            setOtherEmployees([]);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    useEffect(() => {
        if (!isLoading) {
            fetchEmployeeList(employerId)
        }
    },[employerId]);

    const saveEmployee = async (employee) => {
        const res = await requestSaveEmployee(employee);
        if (res.sts_code === ResponseStatus.SUCCESS) {
            showSuccessMessageSaveData(res.sts_code)
        } else {
            alertMessage(res.sts_code)
        }
    }


    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Current employees</h3>
                    {/*<div className={'card-tools'}>*/}
                    {/*    <button type='button' className='btn btn-primary btn-sm'*/}
                    {/*            onClick={() => onSave()}>Save*/}
                    {/*    </button>*/}
                    {/*</div>*/}
                </div>
                <div className='card-body table-responsive p-0 w-100'>
                    <EmployeeTableList employeeList={currentEmployees} onSave={saveEmployee} />
                </div>
            </div>

            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Other employees</h3>
                    {/*<div className={'card-tools'}>*/}
                    {/*    <button type='button' className='btn btn-primary'*/}
                    {/*            onClick={() => onSave()}>Save*/}
                    {/*    </button>*/}
                    {/*</div>*/}
                </div>
                <div className='card-body table-responsive w-100'>
                    <EmployeeTableList employeeList={otherEmployees} onSave={saveEmployee}/>
                </div>
            </div>
        </>
    )
}

export default EmployeesContent;
